import "./App.css";
import { useRoutes } from "react-router-dom";
import { UseRoute } from "./routes/route";
import { apiHeader } from "./helpers/api_helper";
import { onMessageListener } from "./firebase/firebase";
import { useEffect } from "react";
import { getMyInfoAxios, UpdateProfile } from "./services/propertyServices";
import SwapTokenAssets from "./components/Modals/SwapTokenAssets";
import { IsWalletAddressesEqual } from "./common/utility";
import { inAppWallet } from "thirdweb/wallets";
import { useActiveAccount, useConnect } from "thirdweb/react";
import { client } from "./runtime.config";

//--------v5--------
const wallet = inAppWallet();

function App() {
  document.title = "SOLOS";
  const auth = localStorage.getItem("reg-data");
  const activeAccount=useActiveAccount();
  const { connect } = useConnect();

  apiHeader();

  useEffect(() => {
    let res = JSON.parse(auth);
    if (res) {
      //-------v5-------
      wallet
        .autoConnect({
          client,
          strategy: "auth_endpoint",
          payload: JSON.stringify({ userId: `${res?.data?._id}` }),
          encryptionKey: `${res?.data?.walletRecoveryKey}`,
          recoveryCode: `${res?.data?.walletRecoveryKey}`,
        })
        .then((authResult) => {
          console.log(authResult, "authResult");
          connect(wallet)
            .then((res) => {
              console.log(res, "connection success");
            })
            .catch((err) => {
              console.log(err, "connection error");
            });
        })
        .catch((err) => {
          console.log(err, "authenticate error");
          wallet
            .connect({
              client,
              strategy: "auth_endpoint",
              payload: JSON.stringify({ userId: `${res?.data?._id}` }),
              encryptionKey: `${res?.data?.walletRecoveryKey}`,
              recoveryCode: `${res?.data?.walletRecoveryKey}`,
            })
            .then((authResult) => {
              console.log(authResult, "authResult");
              connect(wallet)
                .then((res) => {
                  console.log(res, "connection success");
                })
                .catch((err) => {
                  console.log(err, "connection error");
                });
            })
            .catch((err) => {
              console.log(err, "authenticate error");
            });
        });

    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);

  useEffect(() => {
    if (auth) {
      getdata().then((user) => {
        if (user) {
          if (activeAccount?.address) {
            let hasAddress = user?.walletAddress;
            if (!hasAddress || !IsWalletAddressesEqual(hasAddress, activeAccount?.address)) {
              UpdateProfile({ walletAddress: activeAccount?.address })
                .then((response) => {
                  if (response.status === 200) {
                    getdata();
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeAccount?.address]);

  const getdata = async () => {
    let user = JSON.parse(auth);
    let token = user?.data?.token;
    // console.log(token, "token");

    return await getMyInfoAxios(token)
      .then((res) => {
        // console.log(
        //   +res?.data?.isKYCConfirmed === 1 ? "true" : "false",
        //   "res?.data"
        // );
        // localStorage.setItem(
        //   "isKycCompleted",
        //   +res?.data?.isKYCConfirmed === 1 ? "true" : "false"
        // );

        /* facetec kyc hide */
        localStorage.setItem(
          "isKycCompleted", "true"
        );
        // console.log(res.data, "res.data");
        return res.data;
      })
      .catch((err) => {
        console.log(err, "err");
        return null;
      });
  };



  onMessageListener()
    .then((payload) => {
      // console.log("Received foreground message: ", payload);
      // const {
      //   notification: { title, body },
      // } = payload;
      // // toast(<ToastifyNotification title={title} body={body} />);
      // alert(body)
    })
    .catch((err) =>
      console.log("An error occured while retrieving foreground message. ", err)
    );

  // const ToastifyNotification = ({ title, body }) => (
  //   <div className="push-notification">
  //     <h2 className="push-notification-title">{title}</h2>
  //     <p className="push-notification-text">{body}</p>
  //   </div>
  // );

  let element = useRoutes(UseRoute(auth));

  return <>
    <SwapTokenAssets />
    {element}
  </>;
}

export default App;
